var map = {
	"./DrLubhani/ChangeColor": [
		780,
		186
	],
	"./Ganga/ChangeColor": [
		782,
		192
	],
	"./Indus/ChangeColor": [
		784,
		205
	],
	"./Kabini/ChangeColor": [
		786,
		212
	],
	"./Kaveri/ChangeColor": [
		694,
		21
	],
	"./Luni/ChangeColor": [
		788,
		218
	],
	"./Narmada/ChangeColor": [
		790,
		221
	],
	"./Nethravathi/ChangeColor": [
		792,
		228
	],
	"./Neyyar/ChangeColor": [
		794,
		233
	],
	"./Periyar/ChangeColor": [
		796,
		236
	],
	"./SAANVI/ChangeColor": [
		798,
		246
	],
	"./Sabarmathi/ChangeColor": [
		800,
		253
	],
	"./Sparsh/ChangeColor": [
		802,
		259
	],
	"./Sutlej/ChangeColor": [
		804,
		263
	],
	"./Yamuna/ChangeColor": [
		806,
		269
	],
	"./pamba/ChangeColor": [
		808,
		278
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2073;
module.exports = webpackAsyncContext;